<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { start, end } from "./index.vue";

export default {
    created() {},
    props: {
        handlerCodeSearch: {
            type: Function,
            required: true,
        },
        searchQuery: {
            type: Object,
            required: true,
        },
        selectOption: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            orderStatusOps: [
                { value: 0, label: "未支付" },
                { value: 2, label: "已支付" },
            ],
            orderInvoiceStatusOps: [
                { value: 1, label: "待开发票" },
                { value: 2, label: "已开发票" },
            ],
        };
    },
    methods: {
        reset() {
            this.$clearObject(this.searchQuery);
            this.searchQuery.orderTimeBegin = start;
            this.searchQuery.orderTimeEnd = end;
        },
        change(value, type) {
            this.$emit("change", { value, type });
        },
    },
    components: {},
};
</script>
<template>
    <div class="name-search">
        <el-row :gutter="20">
            <el-col :span="5">
                <el-input
                    v-model="searchQuery.orderId"
                    @change="change($event, 'orderId')"
                    placeholder="订单号"
                ></el-input>
            </el-col>
            <el-col :span="6">
                <el-select
                    v-model="searchQuery.orderStatus"
                    class="common-width"
                    placeholder="订单状态"
                    @change="change($event, 'orderStatus')"
                >
                    <el-option
                        v-for="item in orderStatusOps"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <el-select
                    v-model="searchQuery.orderInvoiceStatus"
                    class="common-width"
                    placeholder="发票状态"
                    @change="change($event, 'orderInvoiceStatus')"
                >
                    <el-option
                        v-for="item in orderInvoiceStatusOps"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px">
            <el-col :span="6">
                <el-date-picker
                    class="common-width"
                    v-model="searchQuery.orderTimeBegin"
                    type="datetime"
                    placeholder="订单开始日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="change($event, 'orderTimeBegin')"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="6">
                <el-date-picker
                    class="common-width"
                    v-model="searchQuery.orderTimeEnd"
                    type="datetime"
                    placeholder="订单结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="change($event, 'orderTimeEnd')"
                >
                </el-date-picker>
            </el-col>
            <el-col :span="7">
                <el-button type="primary" @click="handlerCodeSearch"
                    >搜索</el-button
                >
                <el-button type="primary" @click="reset">重置</el-button>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%
</style>
